import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { theme } from '../../shared/theme/theme';
import { useAuth } from '../../infrastructure/auth/AuthContext';

export const ProfileScreen = () => {
  const { session, signOut } = useAuth();

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Profil</Text>
      <Text style={styles.email}>{session?.user.email}</Text>
      <TouchableOpacity style={styles.signOutButton} onPress={signOut}>
        <Text style={styles.signOutText}>ODHLÁSIT SE</Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.colors.background,
    padding: 30,
    paddingTop: 80,
  },
  title: {
    fontSize: 28,
    fontWeight: '900',
    color: theme.colors.text.main,
    marginBottom: 8,
  },
  email: {
    fontSize: 14,
    color: theme.colors.text.muted,
    marginBottom: 40,
  },
  signOutButton: {
    height: 54,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: '#D32F2F',
    justifyContent: 'center',
    alignItems: 'center',
  },
  signOutText: {
    color: '#D32F2F',
    fontWeight: '900',
    letterSpacing: 1,
  },
});
